import { axiosClient } from 'www/utils'
import type {
  ApiDoctorContactsParamsGet,
  ApiDoctorContactsResponseGet,
} from 'www/vue_components/common/DoctorContacts/api/apiDoctorContacts.types'

export default {
  get(params: ApiDoctorContactsParamsGet) {
    return axiosClient.get<ApiDoctorContactsResponseGet>('/api/doctor/contacts/', {
      params,
    })
  },
}
